import {ILogger, LogLevel} from '@/utils/ILogger';

import logdown from 'logdown';

export class LogdownLogger implements ILogger {
  public static defaultOptions: logdown.LogdownOptions = {
    markdown: true,
  };

  private logdown: logdown.Logger;

  constructor(private prefix: string, opts?: logdown.LogdownOptions) {
    const options = opts !== undefined ? opts : LogdownLogger.defaultOptions;
    this.logdown = logdown(prefix, options);
    this.logdown.state = { isEnabled: true };
  }

  public trace(...args: any[]): ILogger {
    this.log(LogLevel.TRACE, ...args);
    return this;
  }

  public debug(...args: any[]): ILogger {
    this.log(LogLevel.DEBUG, ...args);
    return this;
  }

  public info(...args: any[]): ILogger {
    this.log(LogLevel.INFO, ...args);
    return this;
  }

  public warn(...args: any[]): ILogger {
    this.log(LogLevel.WARN, ...args);
    return this;
  }

  public error(...args: any[]): ILogger {
    this.log(LogLevel.ERROR, ...args);
    return this;
  }

  public fatal(...args: any[]): ILogger {
    this.log(LogLevel.FATAL, ...args);
    return this;
  }

  public log(level: LogLevel, ...args: any[]): ILogger {

    switch (level) {
      case LogLevel.TRACE:
        this.logdown.debug(...args);
        break;

      case LogLevel.DEBUG:
        this.logdown.debug(...args);
        break;

      case LogLevel.INFO:
        this.logdown.log(...args);
        break;

      case LogLevel.WARN:
        this.logdown.warn(...args);
        break;

      case LogLevel.ERROR:
        this.logdown.error(...args);
        break;

      case LogLevel.FATAL:
        this.logdown.error(...args);
        break;

    }

    return this;
  }
}
